import { BRIEF_LIST_QUERY_KEY } from "@entities/brief/lib/constants";
import { GLOBAL_DISCOVERY_NOTIFICATIONS_QUERY_KEY } from "@entities/global-discovery/constants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { ISuggestInfluencerUsernameRequest } from "@shared/lib/types/brief";
import { Typography } from "antd";
import { BriefService } from "../services/brief.service";

const { Text } = Typography;

export function useSuggestInfluencerByUsernameBulk() {
  const {
    mutate: suggest,
    isLoading: isSuggesting,
    isSuccess: isSuggested,
    variables,
  } = useMutation({
    mutationFn: ({ data }: { data: ISuggestInfluencerUsernameRequest }) =>
      BriefService.suggestInfluenceByUsernameBulk(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, newInfluencers, data) => {
      ToastService.success("Added creators successfully");
      c.invalidateQueries({
        queryKey: [...GLOBAL_DISCOVERY_NOTIFICATIONS_QUERY_KEY],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_LIST_QUERY_KEY],
        exact: false,
      });
    },
  });
  return {
    suggest,
    isSuggesting,
    isSuggested,
    variables,
  };
}
